/**
 * Fill Type Enum
 *
 * Defines the fill options for polygon shapes.
 *
 * @enum {string}
 */
export enum FillType {
  /**
   * No fill - outline only
   * Border visible, interior fully transparent
   */
  None = 'None',

  /**
   * Semi-transparent fill
   * Interior filled with semi-transparent color (60% opacity)
   */
  SemiTransparent = 'SemiTransparent',

  /**
   * Solid color fill
   * Interior filled with opaque color (100% opacity)
   */
  Solid = 'Solid',
}
